import React from "react";

export function AuctionIcon({ className = "" }: { className?: string }) {
	return (
		<svg
			width="64px"
			height="64px"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
      className={className}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.58968 11.411L12.1067 3.894C12.3654 3.63533 12.7848 3.63533 13.0435 3.89401L17.2196 8.07013C17.4783 8.32881 17.4783 8.7482 17.2196 9.00687L9.70255 16.5239C9.44388 16.7826 9.02448 16.7826 8.76581 16.5239L4.58968 12.3478C4.33101 12.0891 4.33101 11.6697 4.58968 11.411ZM3.3876 13.5499C2.46504 12.6273 2.46504 11.1315 3.3876 10.209L10.9046 2.69192C11.8272 1.76936 13.323 1.76936 14.2455 2.69192L18.4217 6.86805C19.3442 7.79062 19.3442 9.28639 18.4217 10.209L16.9298 11.7008L20.2756 15.0466C21.5274 16.2984 21.5274 18.328 20.2756 19.5798C19.0237 20.8316 16.9942 20.8316 15.7423 19.5798L12.3966 16.234L10.9046 17.726C9.98207 18.6486 8.48629 18.6485 7.56373 17.726L3.3876 13.5499ZM13.5986 15.032L16.9444 18.3777C17.5323 18.9657 18.4856 18.9657 19.0735 18.3777C19.6614 17.7898 19.6614 16.8366 19.0735 16.2487L15.7277 12.9029L13.5986 15.032Z"
				fill="currentColor"
			/>
			<path
				d="M2.89832 21.1017H7.62306"
				stroke="currentColor"
				strokeWidth="1.7"
				strokeLinecap="round"
			/>
		</svg>
	);
}
